import { render, staticRenderFns } from "./menuListItem.vue?vue&type=template&id=105ab802"
import script from "./menuListItem.vue?vue&type=script&lang=js"
export * from "./menuListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports